import { url as URL, IMAGE_URL as ImageURL } from "../config";

export const url = URL;
export const IMAGE_URL = ImageURL;
